import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Commonservice } from '../../services/commonservice';

export const authGuard: CanActivateFn = (route, state) => {
  const commonSvc = inject(Commonservice)
  const router = inject(Router);
  return commonSvc.ensureAuthStateInitialized().then(() => {
    if (commonSvc.isLoggedIn) {
      return true;
    }

    return router.createUrlTree(['/signin']);
  });
};
